const homeVisitInformationSchema = {
  visitDate: {
    displayName: 'Data da visita',
    notAvailable: 'Data da visita não informada',
    mask: 'date',
    canCopy: false,
  },
  shift: {
    displayName: 'Turno da visita',
    type: 'string',
    notAvailable: 'Não informado',
  },
  outcomeStatus: {
    displayName: 'Status da visita',
    type: 'string',
    notAvailable: 'Não informado',
  },
  visitReasonIsRegistrationUpdate: {
    displayName: 'Motivo da visita: Atualização cadastral',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsPeriodicVisit: {
    displayName: 'Motivo da visita: Visita periódica',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsActiveSearchForConsultation: {
    displayName: 'Motivo da visita: Busca ativa para consulta',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsActiveSearchForExamination: {
    displayName: 'Motivo da visita: Busca ativa para exame',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsActiveSearchForVaccination: {
    displayName: 'Motivo da visita: Busca ativa para vacinação',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsPregnantWomanFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de gestante',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsPostpartumWomanFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de puérpera',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsNewbornFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de recém-nascido',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsChildFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de criança',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsHypertensionPersonFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de pessoa com hipertensão',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsMalnutritionPersonFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de pessoa com desnutrição',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsDiabetesPersonFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de pessoa com diabetes',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsAsthmaPersonFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de pessoa com asma',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsMentalHealthPersonFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de pessoa com saúde mental',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsAlcoholUserFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de usuário de álcool',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsOtherDrugsUserFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de usuário de outras drogas',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsDischargeFromHospitalization: {
    displayName: 'Motivo da visita: Alta de internação',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsEnvironmentalVectorControl: {
    displayName: 'Motivo da visita: Controle ambiental/vetorial',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsPersonWithLeprosyFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de pessoa com hanseníase',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsPersonWithTuberculosisFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de pessoa com tuberculose',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsRespiratorySymptomaticPersonFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de sintomático respiratório',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsSmokerFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de pessoa tabagista',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsGuidancePrevention: {
    displayName: 'Motivo da visita: Orientação/prevenção',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsHomeboundBedriddenPersonFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de pessoa acamada/domiciliada',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsCopdEmphysemaPersonFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de pessoa com DPOC/enfisema',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsCancerPatientFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de paciente com câncer',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsActiveSearchForBolsaFamiliaConditionalities: {
    displayName: 'Motivo da visita: Busca ativa para condicionalidades do Bolsa Família',
    type: 'boolean',
    notAvailable: 'Não informado',
  },

  visitReasonIsRehabilitationOrPersonWithDisabilityFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de pessoa em reabilitação ou com deficiência',
    type: 'boolean',
    notAvailable: 'Não informado',
  },

  visitReasonIsOtherChronicDiseasesPersonFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de pessoa com outras doenças crônicas',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsSocialVulnerabilityConditionsFollowUp: {
    displayName:
      'Motivo da visita: Acompanhamento de pessoa em condições de vulnerabilidade social',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
  visitReasonIsBolsaFamiliaConditionalitiesFollowUp: {
    displayName: 'Motivo da visita: Acompanhamento de condicionalidades do Bolsa Família',
    type: 'boolean',
    notAvailable: 'Não informado',
  },

  visitReasonIsInvitationToCollectiveActivitiesHealthCampaign: {
    displayName: 'Motivo da visita: Convite para atividades coletivas/campanha de saúde',
    type: 'boolean',
    notAvailable: 'Não informado',
  },

  visitReasonIsOther: {
    displayName: 'Motivo da visita: Outro motivo',
    type: 'boolean',
    notAvailable: 'Não informado',
  },
}

export default homeVisitInformationSchema
